import { createContext } from 'react'

export const DialogContext = createContext()
DialogContext.displayName = 'DialogContext'
